export default __webpack_public_path__ + "static/media/add_member_icon.8167160e.png";